// extracted by mini-css-extract-plugin
export default {"page":"Ri-z","cartModal":"Si-z","checkout":"Ti-z","placeholder":"Ui-z","account":"Vi-z"};